export enum PoolName {
  WethUsdc = "weth-usdc",
  WethUsdce = "weth-usdce",
  ArbUsdc = "arb-usdc",
  ArbUsdce = "arb-usdce",
  GmxUsdc = "gmx-usdc",
  WbtcWeth = "wbtc-weth",
}
